const CONTACT_HQ = 'Contact head office';
const NAIROBI_CBD = 'Nairobi CBD';
const NGONG_ROAD = 'Ngong Road';

/** Approved motor valuers — shared by agent and customer motor flows. */
export const MOTOR_VALUERS = [
  {
    id: 'capital-alliance',
    name: 'Capital Alliance Valuers & Assessors Ltd',
    contact: 'Nancy Njeri',
    phone: '0700298666 / 0731747311',
    email: 'jane@capitalalliance-kenya.com',
    hq: 'Emmak Court, Parklands Rd, Westlands, Nairobi',
    areas: ['Westlands', 'Parklands', 'Nairobi'],
    towns: ['Nairobi', 'Mombasa'],
  },
  {
    id: 'links-valuers',
    name: 'Links Valuers and Assessors Ltd',
    contact: 'Jane Kanyeki',
    phone: '0707798383',
    email: 'jane.kanyeki@linksvaluers.com',
    hq: 'Pamstech House, 3rd Floor, Nairobi CBD',
    branches: [
      { location: 'Upperhill', address: 'Upperhill Springs Hotel, Opp CIC, Mara Road' },
      { location: 'Kitengela', address: 'Milele Centre, 1st Floor, Behind Equity Bank, Nairobi-Namanga Rd' },
      { location: 'Kiambu', address: 'Bishop Magua House, 3rd Floor' },
      { location: 'Thika', address: 'Emko Plaza, Mezzanine Floor, Off Nairobi-Garissa Rd' },
      { location: 'Mombasa', address: 'Galaxy Plaza, Opposite CMC Motors, Off Moi Avenue' },
      { location: 'Nakuru', address: 'Saifee House, 1st Floor, Kenyatta Avenue' },
      { location: 'Meru', address: 'Meru Teachers House, 3rd Floor, Opp Barclays Bank' },
      { location: 'Kisumu', address: 'Harleys House, 2nd Floor, B10 Oginga Odinga Street' },
      { location: 'Nyeri', address: 'Old Batian House, 1st Floor' },
      { location: 'Kisii', address: 'Ouru Center, 1st Floor, Above Family Bank' },
      { location: 'Kitale', address: 'Yes Plaza, 1st Floor, M5, Opposite Equity Bank, Kenyatta Street' },
      { location: 'Eldoret', address: 'Nandi Arcade, Oloo Street, Opposite Finns Garage' },
      { location: 'Kakamega', address: CONTACT_HQ },
    ],
    areas: ['CBD', 'Upperhill', 'Kitengela', 'Uthiru', 'Kangemi', 'Parklands', 'Eastlands', 'Langata', NGONG_ROAD],
    towns: ['Nairobi', 'Mombasa', 'Nakuru', 'Meru', 'Upperhill', 'Kisumu', 'Kitengela', 'Kiambu', 'Eldoret', 'Thika', 'Nyeri', 'Kisii', 'Kitale', 'Kakamega'],
    mobile: true,
  },
  {
    id: 'xenon',
    name: 'Xenon Auto Assessors and Valuers Ltd',
    contact: 'Kennedy Kyalo',
    phone: '0700799054',
    email: 'xenonautoassessors@gmail.com',
    hq: 'Mombasa (mobile nationwide)',
    areas: [NAIROBI_CBD],
    towns: ['Nairobi', 'Nakuru', 'Kisumu', 'Eldoret', 'Mombasa', 'Meru', 'Kitui'],
    mobile: true,
  },
  {
    id: 'speedsta',
    name: 'Speedsta Motors Ltd',
    contact: 'Esther Mwangi',
    phone: '0720200623',
    email: 'speedstamotors@gmail.com',
    hq: 'Nairobi (mobile valuers)',
    areas: ['Ruiru', 'Mlolongo', 'Uthiru', NAIROBI_CBD],
    towns: ['Nairobi', 'Ruiru', 'Mlolongo', 'Uthiru', 'Nakuru', 'Nyeri', 'Mombasa', 'Kitui'],
    mobile: true,
  },
  {
    id: 'regent',
    name: 'Regent Automobile Valuers and Assessors Ltd',
    contact: 'Walter Mugo',
    phone: '0721 471 803 / 0712 636 365',
    email: 'regent.wariia@gmail.com',
    hq: 'TRV Office Plaza, Muthithi Road, Westlands, Nairobi',
    branches: [
      { location: 'Westlands (HQ)', address: 'TRV Office Plaza, Muthithi Rd, 2nd Floor, Wing 2B' },
      { location: 'Buruburu', address: 'Buruburu Complex, Room B3' },
      { location: NGONG_ROAD, address: 'Jameson Court Block B, Office No. 10, 50m from China Center' },
      { location: 'Pangani', address: 'Muthaiga Square, 3rd Floor' },
      { location: 'Upperhill', address: 'Along Ngong Road, Jameson Court' },
      { location: 'Kitengela', address: 'Betty Plaza, 3rd Floor, Rm 108' },
      { location: 'Ruiru', address: CONTACT_HQ },
      { location: 'Mombasa', address: 'Yunis Building, 3rd Floor, Room No. 4' },
      { location: 'Nakuru', address: 'Spikes Centre, Kenyatta Avenue, 4th Floor' },
      { location: 'Eldoret', address: CONTACT_HQ },
      { location: 'Kisumu', address: CONTACT_HQ },
      { location: 'Thika', address: CONTACT_HQ },
      { location: 'Meru', address: '3rd Floor, Room 18' },
      { location: 'Nyeri', address: CONTACT_HQ },
      { location: 'Embu', address: CONTACT_HQ },
      { location: 'Kisii', address: CONTACT_HQ },
      { location: 'Kitui', address: 'KCB Building, 2nd Floor, Left Wing, Rm No. 4' },
    ],
    areas: ['Westlands', 'Buruburu', NGONG_ROAD, 'Pangani', 'Upperhill', 'Kitengela'],
    towns: ['Nairobi', 'Mombasa', 'Nakuru', 'Eldoret', 'Kisumu', 'Thika', 'Meru', 'Nyeri', 'Embu', 'Kisii', 'Ruiru', 'Kitengela', 'Kitui'],
  },
  {
    id: 'safety',
    name: 'Safety Surveyors Ltd',
    contact: 'Agnes',
    phone: '0705678012 / 0722421695',
    email: 'motor@safetysurveyors.com',
    hq: 'Occidental House, Baricho Road, Industrial Area, Nairobi',
    areas: ['Industrial Area', NAIROBI_CBD],
    towns: ['Nairobi'],
  },
  {
    id: 'solvit',
    name: 'Solvit Ltd',
    contact: 'David Gichuki',
    phone: '0769737442 / 0794517975',
    email: 'dgichuki@solvit.co.ke',
    hq: 'Springette Business Park, Block G, Lower Kabete Road, Nairobi',
    areas: ['Lower Kabete', 'Spring Valley', NAIROBI_CBD],
    towns: ['Nairobi', 'Mombasa', 'Kisumu', 'Nakuru', 'Eldoret', 'Meru', 'Nyeri', 'Thika', 'Kisii', 'Kitale', 'Kiambu', 'Kitui', 'Machakos', 'Embu', 'Naivasha', 'Bungoma', 'Garissa', 'Nanyuki', 'Narok', 'Nyahururu', 'Kenol'],
    mobile: true,
  },
  {
    id: 'kevo',
    name: 'Kevo Motor Valuers & Assessors Ltd',
    contact: 'Sophia Miriko',
    phone: '0713909118 / 0754781825',
    email: 'kevomotor@gmail.com',
    hq: 'Banana Raini Road, Kiambaa, Kiambu',
    areas: ['Kiambu', 'Kiambaa'],
    towns: ['Kiambu'],
  },
  {
    id: 'topnotch',
    name: 'Top Notch Valuers and Assessors',
    contact: 'Michael Maina',
    phone: '0704861492',
    email: 'info@topnotchvaluers.co.ke',
    hq: 'CPA Centre, Ruaraka, Thika Road, Nairobi',
    areas: ['Ruaraka', 'Thika Road', 'Kasarani'],
    towns: ['Nairobi'],
  },
  {
    id: 'topcover',
    name: 'Top Cover Automobile Valuers and Assessors Ltd',
    contact: 'Robert Githae',
    phone: '0743514503 / 0722940892',
    email: 'info@topcovervaluers.co.ke',
    hq: 'Pangani, Muranga Road, Nairobi',
    areas: ['Pangani', 'Muranga Road', NAIROBI_CBD],
    towns: ['Nairobi'],
  },
];

export const MOTOR_NAIROBI_AREAS = [
  'CBD', 'Westlands', 'Upperhill', 'Pangani', 'Industrial Area',
  'Parklands', 'Thika Road / Ruaraka', NGONG_ROAD, 'Lower Kabete',
  'Eastlands / Buruburu', 'Kitengela', 'Ruiru', 'Mlolongo', 'Uthiru',
  'Kiambu',
];

export function getValuerTownOptions(valuers = MOTOR_VALUERS) {
  const towns = new Set();
  valuers.forEach((v) => v.towns.forEach((t) => towns.add(t)));
  return [...towns].sort();
}

export function filterValuers(valuers, locationFilter, searchQuery = '') {
  if (!locationFilter) return [];
  return valuers.filter((v) => {
    const townMatch = v.towns.includes(locationFilter);
    if (!townMatch) return false;
    if (locationFilter === 'Nairobi' && searchQuery) {
      return v.areas.some((a) => a.toLowerCase().includes(searchQuery.toLowerCase())) || v.mobile;
    }
    return true;
  });
}

export function relevantValuerBranch(valuer, locationFilter, searchQuery = '') {
  if (!valuer?.branches?.length) return null;
  const filter = searchQuery || locationFilter;
  return valuer.branches.find((b) => b.location.toLowerCase().includes(filter.toLowerCase()))
    || valuer.branches[0];
}
